// extracted by mini-css-extract-plugin
export default {"editCta":"_4FyT1_AP","header":"_3ckiHX_i","description":"_1_-j0_MV","icon":"_3Ka3u3qo","editTripDetails":"_3ZfcyKGZ"};